module.exports = __webpack_public_path__ + "static/media/icon-question.a3a176be.svg";